<template>
    <div class="main-wrapper no-padding scroll-y custom-scrollbar view-news-single">

        <slide-y-up-transition :duration="800" :delay="200">
            <div v-if="show && data" style="position: relative">
                <ion-badge style="position: absolute; top:15px; right:15px;">{{ data.category }}</ion-badge>
                <img :src="data.image" class="rwd-image"/>
            </div>
        </slide-y-up-transition>

        <div class="inner-padding">
            <slide-x-left-transition :duration="400" :delay="200">
                <page-title v-if="show && data" :title="data.title" :back="true" :routeName="'Dashboard'"></page-title>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="500" :delay="300">
                <h6 v-if="show && data" class="text-up text-gray-light mt-0">{{ data.created_at }}</h6>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="600" :delay="400">
                <div v-if="show && data" class="rte" v-html="data.content"></div>
            </slide-x-left-transition>
            <ion-button mode="ios" expand="block" class="mt-10 mb-10" @click="goBack">
                <svg @click="goBack" class="icon icon-chevron-back-white"><use xlink:href="#icon-chevron-back-white"></use></svg>
                <span style="display: inline-block; vertical-align: middle"><strong>Wróć</strong></span>
            </ion-button>
        </div>

    </div>
</template>

<script>
    import api from '@/services/Api';
    import PageTitle from '@/components/PageTitle.vue';
    import goTo from '@/mixins/goto';

    export default {
        name: 'NewsSingle',
        components: { PageTitle },
        mixins: [goTo],
        data() {
            return {
                show: false,
                data: null
            }
        },
        mounted() {
            this.show = true;
            this.getNewsSingle();
        },
        methods: {
            // todo refactor to vuex
            getNewsSingle(){
                let url = 'knowledges/news/' + this.$route.params.slug;
                api({url: url, method: 'GET'})
                    .then(resp => {
                        this.data = resp.data ? resp.data.data : null
                    })
                    .catch(() => {})
            }
        }
    }
</script>